import React from 'react';
import { Modal } from 'react-bootstrap';
import { Input } from '../../../common/Forms/Input/Input';
import { useWatch } from 'react-hook-form';

export default function CampaignForm({
  isOpen,
  onClose,
  onSubmit,
  register,
  errors,
  editingCampaignId,
  setValue,
  getValues,
  control,
  clearErrorByFiueldName,
}) {
  const dateSinceWatch = useWatch({
    control,
    name: 'dateSince',
  });

  const statusCampaignWatch = useWatch({
    control,
    name: 'status',
    defaultValue: '', 
  });

  const closeForm = () => {
    onClose();
  };

  return (
    <Modal
      size="lg"
      centered
      show={isOpen}
      onHide={closeForm}
      className="surcharges-form-modal"
      onSubmit={onSubmit}
    >
      <Modal.Header closeButton className="border-bottom-0 pb-0">
        <Modal.Title
          style={{ fontSize: '18px', fontWeight: '700', color: '#1a1f36' }}
        >
          {editingCampaignId
            ? 'Editar campaña de activación'
            : 'Nueva campaña de activación'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-3 pb-0 pl-1 pr-1">
        <div id="surcharges-form" className='row' style={{ width: '100%' }}>
          {/* SECCIÓN 1: IDENTIFICACIÓN */}

          <div className="row" style={{ width: '100%' }} >
            <Input
              bootstrap="col-12 col-md-5"
              label="NOMBRE DE LA CAMPAÑA *"
              type="text"
              name="campaignName"
              register={register}
              placeholder="Ej: Activación inmediata"
              errors={errors?.campaignName?.message}
            />
            {statusCampaignWatch !== 'vencida' && statusCampaignWatch !== 'activa' && (
              <>
                <Input
                  bootstrap="col-8 col-md-4"
                  label="DÍAS DE ACTIVACIÓN *"
                  type="number"
                  name="delay"
                  register={register}
                  placeholder="Coloque los días de activación"
                  errors={errors?.delay?.message}
                />
                <div
                  className='col-4 col-md-3'
                  style={{
                    background: '#f6f4ef',
                    color: '#7d7667',
                    borderRadius: '12px',
                    fontSize: '16px',
                    padding: '8px 16px',
                    alignSelf: 'flex-end',
                    minHeight: '48px',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <p>0 = mismo día de la compra</p>

                </div>
              </>
            )}
          </div>

          {
            statusCampaignWatch !== 'vencida' && statusCampaignWatch !== 'activa' && (
              <div className="row" style={{ width: '100%' }} >
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'FECHA DE INICIO *'}
                  type={'date'}
                  name={'dateSince'}
                  placeholder={''}
                  register={register}
                  errors={errors?.dateSince?.message}
                  control={control}
                  minDate={new Date()} // Fecha actual como mínimo
                />
                <Input
                  bootstrap={'col-12 col-md-6'}
                  label={'FECHA DE FIN *'}
                  type={'date'}
                  name={'dateUntil'}
                  placeholder={''}
                  register={register}
                  errors={errors?.dateUntil?.message}
                  control={control}
                  minDate={dateSinceWatch ? new Date(dateSinceWatch) : new Date()} // Fecha de desde como mínimo
                />
              </div>
            )
          }

          <div className="row" style={{ width: '100%' }}>
            <Input
            bootstrap={'col-12'}
            label={'NOTA / MOTIVO'}
            type={'textarea'}
            name={'note'}
            register={register}
            placeholder={'Ej: Activación inmediata por temporada de viajes'}
            errors={errors?.note?.message}
            rows={5}
          />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-top-0 pt-0 pb-3 pl-3 pr-3">
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', gap: '8px' }}>
          <button
              type="button"
              className="surcharges-form__btn-cancel"
              onClick={closeForm}
            >
              Cancelar
            </button>

            <button
              type="submit"
              form="surcharges-form"
              className="surcharges-form__btn-submit"
              onClick={onSubmit}
            >
              {editingCampaignId ? 'Guardar' : 'Crear'}
            </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
